import React, { DispatchWithoutAction, FC, PropsWithChildren, ReactNode, Suspense } from 'react'
import { OnLoaded } from './OnLoaded'

export const ExtendedSuspense: FC<
  { onLoaded: DispatchWithoutAction; fallback?: ReactNode } & PropsWithChildren
> = ({ onLoaded, children, fallback }) => {
  return (
    <Suspense fallback={fallback}>
      <OnLoaded callback={onLoaded} />

      {children}
    </Suspense>
  )
}
